export default __webpack_public_path__ + "static/media/background.89df4d14.jpg";